import lodashMerge from 'lodash/merge';
import queryString from 'query-string';

import {assertDependencies} from '../lib/util';

const PROVIDER_NAME = 'query_string';

const MANIFEST = require('./manifest');

const DEFAULT_OPTIONS = {
	// Key under which user id will be provided within query string
	// key: 'user_id',
	// api: 'https://api.spinviewglobal.com/api/v1/notifications/preview/generic',
	base_url: 'https://example.org/',
	token: '',
	body: {
		content: '',
		recipients: []
	}
};

function MailNotify(options = DEFAULT_OPTIONS, deps = MANIFEST.dependencies) {
	const thisMailNotify = this;

	options = lodashMerge({}, DEFAULT_OPTIONS, options);
	assertDependencies(MANIFEST.name, MANIFEST.dependencies, deps);


	const apiBaseUrl = deps.SPINVIEW_OPTIONS.AudienceTrackerApi.base_url || options.base_url;
	let baseUrl = apiBaseUrl[apiBaseUrl.length - 1] === '/'
		? apiBaseUrl.slice(0, -1)
		: apiBaseUrl;

	const log = deps.logger.child(MANIFEST.name); // eslint-disable-line no-unused-vars

	// let _userId = fetchUserId();

	Object.assign(thisMailNotify, /** @lends MailNotify.prototype */ {
		notify,
		// getProviderName: () => PROVIDER_NAME
	});

	// function getUserId(callback) {
	// 	if (callback) {
	// 		callback(null, _userId);
	// 	}
	// 	return _userId;
	// }

	// function notify(endpoint, params) {

	// 	fetch(`${baseUrl}/api/v1/${endpoint}`, {
	// 	  method: 'POST',
	// 	//   mode: 'no-cors',
	// 	  headers: {
	// 		"x-auth-token": params["token"] || options.token,
	// 		"content-type": "application/json",
	// 	  },
	// 	  "body": params.body || options.body,
	// 	})
	// 	.then(res => res.json())
	// 	.then(res => {

	// 		console.log(res, 'MAIL RESULT');
	// 	});
	// }

	function notify(endpoint, params) {
		const combinedUrl = baseUrl+'/api/v1/'+endpoint;
		const settings = {
			method: 'POST',
			url: combinedUrl,
			contentType: 'application/json',
			accepts: 'json',
			crossDomain: true,
			data: params
				? JSON.stringify(params)
				: undefined,
			complete: onComplete
		};

		return jQuery.ajax(settings);
	}

	function onComplete(jqXHR, textStatus) {
		const responseData = jqXHR.responseJSON || jqXHR.responseText || null;

		if (textStatus === 'success') {
			// Happy path
			console.log(responseData, '>>>>RESPONSE')
			// return callback && callback(null, responseData);
		} else {
			console.log({jqXHR, textStatus}, '!!!!!')
		}
	}

	// function fetchUserId() {
	// 	if (!options.key) {
	// 		// Treat the entire query as user_id
	// 		return deps.location.search;
	// 	}

	// 	const qs = queryString.parse(deps.location.search);
	// 	return qs[options.key] || null;
	// }
}

// *********************************************************************************************************************

export default MailNotify;
